import { Formik, Form as FormikForm } from "formik";
import { userEvent, within } from "@storybook/test";
import StaticClientFields from "./StaticClientFields";
import SampleLandingPage from "test_support/data/SampleLandingPage";
import LandingPageProvider from "../../LandingPageProvider";
import { GET_CONTRACTS_QUERY } from "components/pages/LandingPages/data/queries";
import SampleContracts from "test_support/data/SampleContracts";

export default {
  title: "Composites/StaticClientFields",
  component: StaticClientFields,
};

const Template = (args, { parameters }) => {
  const landingPage = {
    ...SampleLandingPage,
    staticFields: parameters.updatedStaticFields,
  };

  return (
    <LandingPageProvider initialState={landingPage} isRefetching={false}>
      <Formik initialValues={landingPage} onSubmit={()=> { console.log('Submit') }}>
        <FormikForm autoComplete="off">
          <StaticClientFields {...args} />
        </FormikForm>
      </Formik>
    </LandingPageProvider>
  );
};

export const Default = {
  render: Template,
  args: {},
  parameters: {
    updatedStaticFields: [
      ...SampleLandingPage.staticFields,
    ],
    reactRouter: {
      routePath: "/vendors/:vendorId/landing-pages/:landingPageId/*",
      routeParams: { vendorId: "1", landingPageId: "d5a493a9" },
      browserPath: "/vendors/1/landing-pages/d5a493a9/main",
    },
    providers: {
      apollo: {
        mocks: [
          {
            request: {
              query: GET_CONTRACTS_QUERY,
              variables: {
                clientIds: ["188", "29", "184", "195"],
                vendorId: "1",
              },
            },
            result: {
              data: {
                contracts: SampleContracts,
              },
            },
          },
        ],
      },
    },
  }
}

export const EmptyState = {
  ...Default,
  parameters: {
    ...Default.parameters,
    updatedStaticFields: [],
  }
}

export const AddAndDelete = {
  ...Default,
  play: async ({canvasElement}) => {
    const canvas = within(canvasElement)
    const addButton = await canvas.findByRole('button', { name: 'Add Static Client Field' })
    await userEvent.click(addButton)

    const container = await canvas.getByLabelText('staticFields[0]')
    await userEvent.hover(container)
    const closeButton = await within(container).findByTestId('CloseIcon')
    await userEvent.click(closeButton)
  },
}
